import { FC } from "react";
import { GridToolbarContainer } from "@mui/x-data-grid-premium";
import { Checkbox, Typography } from "@mui/material";
import { DataExportButton } from "../../../../../../../components/common/buttons/export-button";

export const ExportToolbar: FC<{
  value: boolean;
  onChange: (val: boolean) => void;
  label: string;
  handleExport: () => void;
}> = ({ value, onChange, label, handleExport }) => (
  <GridToolbarContainer sx={{ justifyContent: "flex-end" }}>
    <Checkbox checked={value} onChange={e => onChange(e.currentTarget.checked)} />
    <Typography sx={{ marginRight: "1rem" }}>{label}</Typography>

    <DataExportButton handleExport={handleExport} />
  </GridToolbarContainer>
);
